import {startSoftNav} from '@github-ui/soft-nav/state'
import {visit} from '@github/turbo'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {ssrSafeWindow} from '@github-ui/ssr-utils'

export const softNavigate: typeof visit = (url, turboOptions) => {
  if (isFeatureEnabled('disable_soft_navigate_turbo_visit')) {
    let parsed: URL
    try {
      parsed = new URL(String(url), ssrSafeWindow?.location.href)
    } catch {
      return
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return
    }
    if (turboOptions?.action === 'replace') {
      ssrSafeWindow?.location.replace(parsed.href)
    } else {
      ssrSafeWindow?.location.assign(parsed.href)
    }
    return
  }
  // visit won't fire a `turbo:click` event, so we need to manually start the soft navigation process.
  startSoftNav('turbo')
  visit(url, {...turboOptions})
}
